export const DEFAULT_LOCALE = 'en';
// If you're adding locale see webpack.config.js MomentLocalesPlugin
export const APP_LOCALES = [
    'en-gb',
    'en',
    'en-au',
    'en-ie',
    'en-hk',
    'en-sg',
    'ca',
    'ar',
    'bg',
    'cs',
    'da',
    'de',
    'de-ch',
    'el',
    'es',
    'et',
    'fi',
    'fr',
    'fr-ca',
    'fr-ch',
    'he',
    'hr',
    'hy-am',
    'id',
    'is',
    'it',
    'it-ch',
    'lt',
    'lv',
    'nl',
    'nn',
    'pl',
    'pt',
    'pt-br',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sv',
    'th',
    'tr',
    'uk',
    'zh-cn',
    'zh-hk'
];
// limited list of APP_LOCALES for alpine
export const MOBILE_APP_LOCALES = [
    'ar',
    'th',
    'en',
    'bg',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'et',
    'fi',
    'fr',
    'hr',
    'is',
    'it',
    'lt',
    'lv',
    'nl',
    'nn',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sv',
    'tr',
    'uk',
    'zh-cn',
    'zh-hk'
];
export const APP_LOCALE_LANGUAGES_MAP = {
    'hy-am': 'hy',
    nn: 'no',
    'zh-cn': 'zh-Hans',
    'zh-hk': 'zh-Hant'
};
// Intl.DisplayNames output for these codes depends on the ICU data bundled with the
// platform's JS engine (iOS/JavaScriptCore vs Android/Chromium), so it can render
// inconsistently (eg. wrong word order). Keyed by current UI locale, then language code.
// Any locale not listed here keeps falling back to Intl.DisplayNames.
export const LANGUAGE_LOCAL_NAME_OVERRIDES = {
    en: {
        'zh-Hans': 'Chinese, Simplified',
        'zh-Hant': 'Chinese, Traditional'
    }
};
